import React, { createContext, useContext, useState, useEffect } from "react";

export const DistrictContext = createContext(); // <-- export here

export const DistrictProvider = ({ children }) => {
  const [selectedDistrict, setSelectedDistrict] = useState(() => {
    const mcData = JSON.parse(localStorage.getItem("MCData")) || {};
    return mcData.selectedDistrict || "";
  });

  useEffect(() => {
    const mcData = JSON.parse(localStorage.getItem("MCData")) || {};
    mcData.selectedDistrict = selectedDistrict;
    localStorage.setItem("MCData", JSON.stringify(mcData));
  }, [selectedDistrict]);

  return (
    <DistrictContext.Provider value={{ selectedDistrict, setSelectedDistrict }}>
      {children}
    </DistrictContext.Provider>
  );
};

export const useDistrict = () => useContext(DistrictContext);
